<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap">
<p class="image"><a id="page_5"></a><img alt="image" class="vertical" src="images/f0005-01.jpg"/></p>
</div>
<p class="dedication"><em>Dedicated to my mom and dad, for always encouraging me to pursue my passions, even when they’re made of ice</em>.</p>
<p class="dedication"><em>And of course, to Drew—none of this would exist without you</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?44a63076